import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { AnswerModuleService } from '@core/services/answer-module.service';
import { EditModeService } from '@core/services/edit-mode.service';
import { RedirectService } from '@core/services/redirect.service';
import { PAGE_TITLES, usePageTitle } from '@core/utils/page-title.util';
import { catchError, combineLatest } from 'rxjs';

@Component({
  selector: 'app-edit',
  imports: [],
  templateUrl: './edit.component.html',
  styleUrl: './edit.component.scss',
})
export class EditComponent implements OnInit, OnDestroy {
  constructor(
    private answerModuleService: AnswerModuleService,
    private redirectService: RedirectService,
    private route: ActivatedRoute,
    private editModeService: EditModeService,
  ) {}

  allowNavigation = false;
  private readonly destroyRef = inject(DestroyRef);
  private setPageTitle = usePageTitle();
  private beforeUnloadHandler = this.onBeforeUnload.bind(this);

  onBeforeUnload(event: Event): void {
    event.preventDefault();
  }
  ngOnDestroy(): void {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);

    if (!this.allowNavigation) {
      this.editModeService.clearEditMode();
    }
  }
  ngOnInit(): void {
    this.setPageTitle(
      PAGE_TITLES.INVITATION.key,
      PAGE_TITLES.INVITATION.fallback,
    );

    this.editModeService.setEditMode(true);

    //getEditByResponseId
    combineLatest([this.route.paramMap, this.route.queryParamMap])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([params, query]) => {
        const responseId = params.get('responseId');
        const sId = query.get('sid');
        const userId = query.get('userId'); //Why lower case?
        //console.log(responseId, sId, userId);
        //console.log(params, query);
        if (!responseId) return;
        this.answerModuleService
          .getEditByResponseId(responseId, userId, sId)
          .pipe(
            takeUntilDestroyed(this.destroyRef),
            catchError(() => {
              this.allowNavigation = true;
              return [];
            }),
          )
          .subscribe((data) => {
            if (data.body) {
              this.allowNavigation = true;
              this.redirectService.redirectToView(data.body);
            }
          });
      });
  }
}
